export const LIST = "GAME_MAINTENANCE_LIST";
export const SHOW = "GAME_MAINTENANCE_SHOW";
export const UPDATE_STATUS = "GAME_MAINTENANCE_UPDATE_STATUS";
export const DETAILS = "GAME_MAINTENANCE_DETAILS";
export const UPDATE = "GAME_MAINTENANCE_UPDATE";
